import Form  from "../../../Lib/Forms/Form";
import User  from "../User";
import store from '../../../store';


export default class EditProfileForm extends Form {


    constructor(user) {
        super();

        this.user_name        = user.name;
        this.email            = user.email;
        this.password         = '';
        this.current_password = '';

        this.setUser(user);
    }

    setUser(user) {
        this.user = new User(user.id, user.name, user.email, user.avatar)
    }

    rules() {
        return {
            user_name: ['required'],
            email: ['required', 'email'],
            password: ['min:char:6'],
            current_password: ['required'],
        }
    }

    submit() {
        return User.update({
            name: this.user_name,
            email: this.email,
            password: this.password,
            current_password: this.current_password
        });
    }

}
